import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-facebook-icon",
  "use": "icon-facebook-icon-usage",
  "viewBox": "0 0 38 38",
  "content": "<symbol viewBox=\"0 0 38 38\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-facebook-icon\">\n<path d=\"M37.333 18.7135C37.333 8.3836 28.971 0 18.667 0C8.36299 0 0 8.3836 0 18.7135C0 27.7708 6.42098 35.3123 14.933 37.0526V24.3275H11.2V18.7135H14.933V14.0351C14.933 10.4234 17.864 7.4854 21.467 7.4854H26.133V13.0994H22.4C21.373 13.0994 20.533 13.9415 20.533 14.9708V18.7135H26.133V24.3275H20.533V37.3333C29.96 36.3977 37.333 28.4257 37.333 18.7135Z\" fill=\"#A7F900\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol